// import Cropper from "react-easy-crop";
import Slider from "@material-ui/core/Slider";
import getCroppedImg from "./GetCroppedImage";

import { useDispatch, useSelector } from "react-redux";
import { useRef, useState } from "react";
import { campaignAction } from "../../store/campaign-store";
import { v4 as uuidv4 } from "uuid";
import UploadService from "../../Services/FileUploadServices";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useParams } from "react-router";

let customfilterCss = "";

const ImageEditor = () => {
  const [cropData, setCropData] = useState("");
  // const [zoom, setZoom] = useState(0);
  const [rotation, setRotation] = useState(0);
  // const [objectFit, setObjectFit] = useState(1);
  const [showFilter, setShowFilter] = useState("show");
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [filterClass, setFilterClass] = useState("filter-normal");
  const [filterTab, setFilterTab] = useState("filter");
  const [brightness, setBrightness] = useState(0);
  const [contrast, setContrast] = useState(0);
  const [saturation, setSaturation] = useState(0);
  const [customFilter, setcustomFilter] = useState("");
  const imageData = useSelector((state) => state.campaign.image_editor);
  const token = useSelector((state) => state.auth.token);
  const single_layer = useSelector((state) => state.campaign.single_layer);
  const editSlideData = useSelector((state) => state.campaign.editSlideData);

  const dispatch = useDispatch();

  const cropperRef = useRef(null);
  const [cropper, setCropper] = useState(Cropper);
  const { camp_id } = useParams();

  const handleClick = (action) => {
    // const imageElement = cropperRef?.current;
    // const cropper = imageElement?.cropper;

    if (action === "close") {
      dispatch(campaignAction.setImageEditor({ content: null }));
    }
    // if (action === "fill") {
    //   var contData = cropper.getContainerData();
    //   setObjectFit(3)
    // }
    // if (action === "fit") {
    //   setObjectFit(2)
    // }
    if (action === "rotate") {
      let val = rotation === 360 ? 0 : rotation + 45;
      setRotation(val);
    }
  };

  const filters = [
    {
      name: "Aden",
      class: "filter-aden",
    },
    {
      name: "Amaro",
      class: "filter-amaro",
    },
    {
      name: "Ashby",
      class: "filter-ashby",
    },
    {
      name: "Brannan",
      class: "filter-brannan",
    },
    {
      name: "Brooklyn",
      class: "filter-brooklyn",
    },
    {
      name: "Charmes",
      class: "filter-charmes",
    },
    {
      name: "Clarendon",
      class: "filter-clarendon",
    },
    {
      name: "Crema",
      class: "filter-crema",
    },
    {
      name: "Dogpatch",
      class: "filter-dogpatch",
    },
    {
      name: "Earlybird",
      class: "filter-earlybird",
    },
    {
      name: "Gingham",
      class: "filter-gingham",
    },
    {
      name: "Ginza",
      class: "filter-ginza",
    },
    {
      name: "Hafe",
      class: "filter-hafe",
    },
    {
      name: "Helena",
      class: "filter-helena",
    },
    {
      name: "Hudson",
      class: "filter-Inkwell",
    },
    {
      name: "Inkwell",
      class: "filter-inkwell",
    },
    {
      name: "Kelvin",
      class: "filter-kelvin",
    },
    {
      name: "Lark",
      class: "filter-lark",
    },
    {
      name: "Lo-fi",
      class: "filter-lofi",
    },
    {
      name: "Ludwing",
      class: "filter-ludwing",
    },
    {
      name: "Maven",
      class: "filter-maven",
    },
    {
      name: "Mayfair",
      class: "filter-mayfair",
    },
    {
      name: "Moon",
      class: "filter-moon",
    },
    {
      name: "Nashville",
      class: "filter-nashvile",
    },
    {
      name: "Perpetua",
      class: "filter-perpetua",
    },
    {
      name: "Poprocket",
      class: "filter-poprocket",
    },
    {
      name: "Reyes",
      class: "filter-reyes",
    },
    {
      name: "Rise",
      class: "filter-rise",
    },
    {
      name: "Sierra",
      class: "filter-sierra",
    },
    {
      name: "Skyline",
      class: "filter-skyline",
    },
    {
      name: "Slumber",
      class: "filter-slumber",
    },
    {
      name: "Stinson",
      class: "filter-stinson",
    },
    {
      name: "Sutro",
      class: "filter-sutro",
    },
    {
      name: "Toaster",
      class: "filter-toaster",
    },
    {
      name: "Valencia",
      class: "filter-valencia",
    },
    {
      name: "Vesper",
      class: "filter-vesper",
    },
    {
      name: "Walden",
      class: "filter-walden",
    },
    {
      name: "Willow",
      class: "filter-willow",
    },
    {
      name: "X-Pro II",
      class: "filter-xpro-ii",
    },
  ];

  const handleCustomFilter = (e, type, value) => {
    e.preventDefault();
    setFilterClass("filter-custom");
    customfilterCss = "";
    if (type === "brightness") {
      setBrightness(value);
      customfilterCss += `brightness(${value + 1}) `;
    } else {
      customfilterCss += `brightness(${brightness + 1}) `;
    }

    if (type === "contrast") {
      setContrast(value);
      customfilterCss += `contrast(${value + 1}) `;
    } else {
      customfilterCss += `contrast(${contrast + 1}) `;
    }

    if (type === "saturation") {
      setSaturation(value);
      customfilterCss += `saturate(${value + 1}) `;
    } else {
      customfilterCss += `saturate(${saturation + 1}) `;
    }

    customfilterCss += `sepia(0) grayscale(0) hue-rotate(0deg)`;
  };

  const handleApply = (event) => {
    event.preventDefault();
    setcustomFilter(customfilterCss);
    // setShowFilter("hide");
  };

  const getImage = async () => {
    try {
      if (typeof cropper !== "undefined") {
        const croppedimage = await getCroppedImg(
          cropData,
          croppedAreaPixels,
          rotation,
          filterClass,
          customFilter
        );

        // generate file from base64 string
        const file = dataURLtoFile(croppedimage, `${uuidv4()}.jpg`);
        // put file into form data
        const data = new FormData();

        data.append("file", file, file.name);

        // now upload

        // console.log(file);

        UploadService.uploadCanvas(file, token, camp_id, (event) => {
          // setProgress(Math.round((100 * event.loaded) / event.total));
        })
          .then((response) => {
            // console.log(response);
            // console.log(response.status);

            if (response.status === 200) {
              updateNewData(response.data.url);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    } catch (e) {
      console.error(e);
      // EditorContextData.loadingHandler(false);
    }
  };

  const updateNewData = async (url) => {
    // console.log(single_layer);
    // return false;
    let new_layer_data = { ...single_layer };
    new_layer_data.src = url;

    // console.log(single_layer);
    // return false;

    await dispatch(campaignAction.setSingleLayerData({ data: new_layer_data }));

    await dispatch(
      campaignAction.setSingleSlideData({ layer_name: single_layer.name })
    );

    dispatch(campaignAction.appendVideoData());

    var newData = { ...editSlideData };

    newData[single_layer.name] = url;
    dispatch(campaignAction.setSlideData({ data: newData }));

    dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: false }));

    dispatch(campaignAction.setImageEditor({ content: null }));
  };

  // const onZoom = (e,zoom) => {
  //   console.log(zoom)
  //   const scaleValue = parseFloat(zoom);
  //   const imageElement = cropperRef?.current;
  //   const cropper = imageElement?.cropper;
  //   cropper.scale(scaleValue);
  //   setZoom(scaleValue)
  // };

  const handleRotate = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    cropper.rotate(90);
  };

  const onCrop = (event) => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    setCroppedAreaPixels(cropper.getCroppedCanvas());
    // console.log(cropper)
    const dataBlob = cropper.getCroppedCanvas({ width: 1920, height: 1080 });
    dataBlob.toBlob(async (blob) => {
      const url = URL.createObjectURL(blob);
      setCropData(url);
    });
  };

  // const handleZoom = (event) => {
  //   // console.log(event.detail.ratio.toFixed(2))

  //   if (event.detail.ratio >= 0.8 || event.detail.ratio < 0.3144) {
  //     event.preventDefault(); // Prevent zoom in
  //   }else{
  //     setZoom(event.detail.ratio)
  //   }
  // }
  // helper function: generate a new file from base64 String
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n) {
      u8arr[n - 1] = bstr.charCodeAt(n - 1);
      n -= 1; // to make eslint happy
    }
    return new File([u8arr], filename, { type: mime });
  };

  return (
    <div className="templateList imageEditorDiv" style={{ overflowY: "auto" }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 p-10-12 border-1 prq-modal-head">
            <a
              href="#0"
              className="btn pull-right "
              onClick={(e) => handleClick("close")}
            >
              CLOSE
            </a>
          </div>
          <div className="col-sm-12 p-10-12 bg-light-gray">
            <div className="container"></div>
          </div>
        </div>
      </div>
      <div className="prq-content-area">
        <div className="prq-image-editor-content">
          <div className="container-fluid">
            <div className="prq-image-editor-header appContainer">
              <div
                className={`prq-image-editor-preview crop-container mx-auto ${filterClass}`}
                style={{
                  filter:
                    filterClass === "filter-custom" ? customfilterCss : "",
                }}
              >
                <div className="datyzE">
                  <Cropper
                    src={imageData}
                    crop={onCrop}
                    // scale={zoom}
                    initialAspectRatio={16 / 9}
                    // zoom={handleZoom}
                    // onZoomChange={setZoom}
                    style={{ height: 275, width: 485 }}
                    viewMode={1}
                    cropBoxMovable={false}
                    cropBoxResizable={false}
                    // minCropBoxWidth={485}
                    // minCropBoxHeight={340}
                    // rotation={rotation}
                    className={`${filterClass} cropper-div`}
                    ref={cropperRef}
                    dragMode={"move"}
                    movable={true}
                    background={false}
                    toggleDragModeOnDblclick={false}
                    // zoomTo={1}
                    onInitialized={(instance) => {
                      setCropper(instance);
                    }}
                  />
                </div>
              </div>

              <div className="prq-image-editor-zoom-control">
                <p className="prq-image-editor-recommended mx-4 my-4">
                  1920 x 1080 px Recommended
                </p>
                <div className="prq-zoom-slider">
                  {/* <Slider
                    value={zoom}
                    min={0.3}
                    max={0.8}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e, zoom) => onZoom(e,zoom)}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="prq-image-editor-settings">
          <div className="prq-image-editor-settings-head">
            <div className="container-fluid">
              <div className="prq-image-editor-settings-menu">
                <ul>
                  <li className="d-none">
                    <button onClick={() => handleClick("fill")}>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/image.svg"
                        }
                        alt="Fill"
                      />
                      Fill
                    </button>
                  </li>
                  <li className="d-none">
                    <button onClick={() => handleClick("fit")}>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/image.svg"
                        }
                        alt="Fit"
                      />
                      Fit
                    </button>
                  </li>
                  <li>
                    <button onClick={handleRotate}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/rotating-arrow-to-the-right.svg"
                        }
                        alt="Rotate"
                      />
                      Rotate
                    </button>
                  </li>
                  <li className="active">
                    <button onClick={() => setShowFilter("show")}>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/filter.svg"
                        }
                        alt="Filter"
                      />
                      Filter
                    </button>
                    {showFilter === "show" && (
                      <ul className="nav prq-tabs-nav">
                        <li>
                          <button
                            className={`filtertabbutton ${
                              filterTab === "filter" ? "active" : ""
                            }`}
                            component="span"
                            underline="none"
                            onClick={() => setFilterTab("filter")}
                          >
                            Filter
                          </button>
                        </li>
                        <li>
                          <button
                            className={`filtertabbutton ${
                              filterTab === "custom" ? "active" : ""
                            }`}
                            component="span"
                            underline="none"
                            onClick={() => setFilterTab("custom")}
                          >
                            Edit
                          </button>
                        </li>
                      </ul>
                    )}
                  </li>
                </ul>
              </div>
              <div className="prq-image-editor-settings-buttons">
                {/* <div className="dropdown">
                                            <button className="btn btn-white btn-border dropdown-toggle" type="button" id="replaceImage" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Replace Image
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="replaceImage">
                                                <a className="dropdown-item" href="/">UPLOAD</a>
                                                <a className="dropdown-item" href="/">GALLERY</a>
                                                <a className="dropdown-item" href="/imageURLModal" data-toggle="modal">IMAGE URL</a>
                                            </div>
                                        </div> */}

                <button
                  onClick={() => handleClick("close")}
                  className="btn btn-danger btn-white btn-border"
                >
                  Cancel
                </button>
                <button onClick={getImage} className="btn btn-warning">
                  Done
                </button>
              </div>
            </div>
          </div>

          {/* <!-- Image Filter Tab Content --> */}
          {showFilter === "show" && (
            <div className="prq-ies-filter-content">
              <div className="container-fluid">
                <div className="tab-content">
                  <div
                    id="tabFilter"
                    className={`tab-pane fade ${
                      filterTab === "filter" ? "show active" : ""
                    }`}
                  >
                    <div className="prq-ies-image-filter">
                      <div className="cNvMxl">
                        {filters.map((filter, index) => {
                          return (
                            <div
                              key={index}
                              className={`filter-item ${
                                filterClass === filter.class
                                  ? "filter-item--selected"
                                  : ""
                              }`}
                              onClick={() => setFilterClass(filter.class)}
                            >
                              <div className="filter-item__img">
                                <img
                                  className={filter.class}
                                  src={imageData}
                                  alt={filter.name}
                                />
                                <span className="filter-item__name">
                                  {filter.name}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* <div className="prq-ies-image-filter-buttons">
                                                    <button onClick={() => setShowFilter('hide')} className="btn btn-secondary btn-border">Cancel</button>
                                                    <button onClick={() => setShowFilter('hide')} className="btn btn-warning">Apply</button>
                                                </div> */}
                  </div>

                  <div
                    id="tabEdit"
                    className={`tab-pane fade ${
                      filterTab === "custom" ? "show active" : ""
                    }`}
                  >
                    <div className="prq-ies-image-filter-edit">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="customfilternamevalues mb-3">
                            <label htmlFor="prq_brightness">
                              {/* <ImBrightnessContrast /> */}
                              &nbsp;&nbsp;Brightness
                            </label>
                            <div className="prq-rangeslider-cvalues">
                              <span className="prq-brightness-output">
                                {brightness}
                              </span>
                            </div>
                          </div>
                          <div className="prq-rangeslider">
                            {/* <input type="range" min="1" max="100" value="80" className="prq-brightness" id="prq_brightness" onChange={handleChange}/> */}
                            <Slider
                              value={brightness}
                              min={-0.9}
                              max={1.5}
                              step={0.1}
                              aria-labelledby="Brightnes"
                              onChange={(e, brightness) =>
                                handleCustomFilter(e, "brightness", brightness)
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="customfilternamevalues mb-3">
                            <label htmlFor="prq_contrast">
                              {/* <img src="/assets/images/contrast.svg" alt="Contrast"/> */}
                              {/* <ImContrast /> */}
                              &nbsp;&nbsp;Contrast
                            </label>
                            <div className="prq-rangeslider-cvalues">
                              <span className="prq-contrast-output">
                                {contrast}
                              </span>
                            </div>
                          </div>
                          <div className="prq-rangeslider">
                            {/* <input type="range" min="1" max="100" value="80" className="prq-contrast" id="prq_contrast" onChange={handleChange}/> */}
                            <Slider
                              value={contrast}
                              min={-0.9}
                              max={1.5}
                              step={0.1}
                              aria-labelledby="Brightnes"
                              onChange={(e, contrast) =>
                                handleCustomFilter(e, "contrast", contrast)
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="customfilternamevalues mb-3">
                            <label htmlFor="prq_saturation">
                              {/* <img src="/assets/images/saturation.svg" alt="Saturation"/> */}
                              {/* <HiColorSwatch /> */}
                              &nbsp;&nbsp;Saturation
                            </label>
                            <div className="prq-rangeslider-cvalues">
                              <span className="prq-saturation-output">
                                {saturation}
                              </span>
                            </div>
                          </div>
                          <div className="prq-rangeslider">
                            {/* <input type="range" min="1" max="100" value="80" className="prq-saturation" id="prq_saturation" onChange={handleChange}/> */}
                            <Slider
                              value={saturation}
                              min={-0.9}
                              max={1.5}
                              step={0.1}
                              aria-labelledby="Brightnes"
                              onChange={(e, saturation) =>
                                handleCustomFilter(e, "saturation", saturation)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="prq-ies-image-filter-buttons">
                        <button
                          className="btn btn-secondary btn-border d-one"
                          onClick={() => setShowFilter("hide")}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-warning"
                          onClick={handleApply}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageEditor;
